import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafePipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(style) {
    return this.sanitizer.bypassSecurityTrustHtml(style);
  }
}
